<div class="page-container">
    <div class="page-header">
        <div class="header-content">
            <h1 class="page-title">User Management</h1>
            <p class="page-subtitle">Manage your team members and their account permissions</p>
        </div>
    </div>

    <div class="card">
        <div class="card-header">
            <div class="search-wrapper">
                <mat-icon class="search-icon">search</mat-icon>
                <input type="text" class="search-input" [(ngModel)]="searchText"
                    placeholder="Search by name, email or role..." />
                <mat-icon *ngIf="searchText" class="clear-icon" (click)="searchText = ''">close</mat-icon>
            </div>

            <button type="button" class="btn-primary" (click)="addNewCustomer()">
                <mat-icon>person_add</mat-icon>
                <span>Add User</span>
            </button>
        </div>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="loading-overlay">
            <mat-spinner diameter="50" color="primary"></mat-spinner>
            <p class="loading-text">Loading users...</p>
        </div>

        <div class="table-container" [class.loading]="isLoading">
            <table class="data-table">
                <thead>
                    <tr>
                        <th class="th-photo">Photo</th>
                        <th>Khmer Name</th>
                        <th>English Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th class="th-actions">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of filteredOrders" class="table-row">
                        <td>
                            <div class="avatar-wrapper">
                                <img [src]="data.photo" alt="User Photo" class="avatar"
                                    onerror="this.src='assets/images/default-avatar.png'" />
                            </div>
                        </td>
                        <td>
                            <span class="cell-text">{{ data.khmerName || '—' }}</span>
                        </td>
                        <td>
                            <span class="cell-text cell-text-primary">{{ data.englishName || '—' }}</span>
                        </td>
                        <td>
                            <span class="cell-text cell-text-secondary">{{ data.email }}</span>
                        </td>
                        <td>
                            <span class="role-badge" [ngClass]="'role-' + data.roleCode">
                                {{ filterUserRole(data.roleCode) }}
                            </span>
                        </td>
                        <td class="actions-cell">
                            <button class="btn-icon-action" (click)="editUser(data, $event)" title="More options">
                                <mat-icon>more_vert</mat-icon>
                            </button>

                            <div *ngIf="selectedUserId === data.id" class="dropdown-menu"
                                [style.top]="dropdownPosition.top"
                                [style.right]="dropdownPosition.right">
                                <button class="dropdown-item" (click)="onEdit(data)">
                                    <mat-icon class="dropdown-icon edit-icon">edit</mat-icon>
                                    <span>Edit User</span>
                                </button>
                                <div class="dropdown-divider"></div>
                                <button class="dropdown-item dropdown-item-danger" (click)="onDelete(data)">
                                    <mat-icon class="dropdown-icon">delete</mat-icon>
                                    <span>Delete User</span>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- Empty State -->
            <div *ngIf="filteredOrders.length === 0" class="empty-state">
                <mat-icon class="empty-icon">person_search</mat-icon>
                <h3>No users found</h3>
                <p>Try adjusting your search or add a new user</p>
            </div>
        </div>

        <div class="card-footer" *ngIf="filteredOrders.length > 0">
            <div class="pagination-info">
                Showing <strong>{{ filteredOrders.length }}</strong> of <strong>{{ datas.length }}</strong> users
            </div>
            <div class="pagination">
                <button class="pagination-btn" [disabled]="currentPage === 1"
                    (click)="getUserList(currentPage - 1)" title="Previous page">
                    <mat-icon>chevron_left</mat-icon>
                </button>

                <ng-container *ngFor="let page of pages">
                    <button class="pagination-btn pagination-number"
                        [ngClass]="{ 'active': page === currentPage }" (click)="getUserList(page)">
                        {{ page }}
                    </button>
                </ng-container>

                <button class="pagination-btn" [disabled]="currentPage === totalPages"
                    (click)="getUserList(currentPage + 1)" title="Next page">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
